import React from 'react';
import styles from './AdvtFullSize.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import logoVideo from '../../assets/video/logoVideo.webm';

import { motion } from 'motion/react';

const AdvtFullSize = React.memo(({ delayTransition }) => {
  const { paddingQR, sizeQR, titleFontSize, qrCode1, qrCode2, title } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      <div className={styles.logoAndTitle}>
        <video
          autoPlay="autoplay"
          muted="muted"
          playsInline
          className={styles.logoBlock}
        >
          <source src={logoVideo} type="video/webm"></source>
        </video>
        {title && (
          <div
            className={styles.title}
            style={{
              fontSize: `${titleFontSize}rem`,
              maxHeight: `${titleFontSize}rem`,
            }}
          >
            {title.split(' ').map((word, idx) => (
              <motion.div
                initial={{ scale: 0, transformOrigin: '50% 100%' }}
                animate={{ scale: 1, transformOrigin: '50% 100%' }}
                transition={{
                  duration: 0.2,
                  delay: idx * 0.2 + delayTransition,
                }}
                key={word + idx}
              >
                {word}
              </motion.div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.8, delay: 1.8 },
              scale: {
                duration: 2.4,
                ease: 'easeOut',
                delay: 1.8 + delayTransition,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.8, delay: 1.8 },
              scale: {
                duration: 2.4,
                ease: 'easeOut',
                delay: 1.8 + delayTransition,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default AdvtFullSize;
